import React from 'react'
import { StyleSheet } from '../stylesheet'
import { parseDeezerLink } from '../../../services/music-player'

export const DeezerEmbed: React.FC<{ deezerLink: string; style?: React.CSSProperties }> = ({ deezerLink, style }) => {
  const player = parseDeezerLink(deezerLink)
  if (!player) return null

  return (
    <iframe title="deezer-widget" style={{ ...styles.frame, ...style }} src={player.uri} allow="encrypted-media; clipboard-write" loading="lazy" />
  )
}

const styles = StyleSheet.create({
  frame: {
    border: 'none',
    borderRadius: 10,
    height: '400px',
    width: '100%',
  },
})
